<ion-header><app-navheader [page] = "isLogin()"></app-navheader>
    <img src="/../assets/img/black-arrow-login.png" class="black-arrow-login"/>
    </ion-header>
    <ion-content padding style="background-color: #04c4fc">
    <ion-item class="header blue-item">
        <h1 class="h1-blue-page">
            SE CONNECTER
        </h1>
    </ion-item>
    <div class="wrapper">
        <div class="pb-spinner" [hidden] = "spinner"></div>
        <button ion-button class="createuser" *ngIf = "buttons" (click)="reconnect()">Réessayer de se connecter</button>
        <button ion-button class="createuser" *ngIf = "buttons" (click)="goToHomePage()">Retour à la page d'accueil</button>
    </div>
    <app-cookie-info></app-cookie-info>
    </ion-content>
    <ion-footer>
      <app-bottom-menu></app-bottom-menu>
    </ion-footer>
